import { render, staticRenderFns } from "./tishiye.vue?vue&type=template&id=c4f1204a&scoped=true"
import script from "./tishiye.vue?vue&type=script&lang=js"
export * from "./tishiye.vue?vue&type=script&lang=js"
import style0 from "./tishiye.vue?vue&type=style&index=0&id=c4f1204a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f1204a",
  null
  
)

export default component.exports